// extracted by mini-css-extract-plugin
module.exports = {"thinHeading":"Heading_thinHeading__1jEEw","Colored":"Heading_Colored__3sT9Y"};